import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    const handleMembersOnlyButtonClick = () => {
        const isDev = window.location.hostname.includes('dev');
        const url = isDev
            ? 'https://membersonly.devdwifd.com/home'
            : 'https://membersonly.dogwifdreads.com/home';

        window.open(url, '_blank');
    };

    return (
        <AppBar position="static" elevation={2} sx={{ backgroundColor: '#d1930d', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)' }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                {/* Logo */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h6" component={Link} to="/" sx={{ color: '#fff', textDecoration: 'none' }}>
                        $DWIFD
                    </Typography>
                </Box>

                {/* Buttons aligned to the right */}
                <Box sx={{ display: 'flex', gap: 2, marginLeft: 'auto' }}>
                    <Button
                        onClick={handleMembersOnlyButtonClick}
                        sx={{
                            backgroundColor: '#000',
                            color: '#d1930d',
                            '&:hover': {
                                backgroundColor: '#fff',
                                color: '#000',
                            },
                        }}
                    >
                        Members Only
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;